export default "https://cdn-static.gokick.com/assets/5a032fdfc840f3d1fce44ec205c52ed2ca8e0677/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";